<script setup lang="ts">
import { getHostname } from '~~/src/api'
import type { List } from '~~/src/types/list'
import type { Prompt, PromptMinified } from '~~/src/types/prompt'
import { Popover, PopoverAnchor, PopoverContent } from '@/components/ui/popover'

const { prompt, list, variant = 'default' } = defineProps<IProps>()
defineOptions({
  name: 'PromptCopy',
})
interface IProps {
  prompt?: Prompt | PromptMinified
  list?: List
  variant?: 'default' | 'mini'
}

const { isSupported, copy, copied } = useClipboard()

const elementalType = computed(() => useElementalTypes().value.find(t => t.id === prompt?.elementalTypeId))

const handleCopyLink = () => {
  if (!isSupported)
    return

  const host = getHostname()
  if (list) {
    copy(list ? `${host}/list/${list.url}` : window.location.href)
    sendGTMEvent({ event: 'list-share' })
  }
  else {
    copy(prompt ? `${host}/${elementalType.value?.name || 'prompt'}/${prompt.url}` : window.location.href)
    sendGTMEvent({ event: 'prompt-share' })
  }
}
</script>

<template>
  <Popover :open="copied">
    <PopoverAnchor>
      <button
        class="flex items-center center
        bg-white border border-soft-gray
        rounded-full cursor-pointer
        color-bluish-softer hover:color-bluish-darker transition-colors"
        text="12px"
        :w="variant === 'mini' ? 8 : 10"
        :h="variant === 'mini' ? 8 : 10"
        @click.prevent.stop="handleCopyLink()"
      >
        <div i-material-symbols:link rotate-135 />
      </button>
    </PopoverAnchor>
    <PopoverContent class="px-3 py-2 w-fit">
      <Text>
        Copied!
      </Text>
    </PopoverContent>
  </Popover>
</template>

<style lang="scss" module>
.copied {
  @apply border-purple;
}
</style>
